module.exports = __webpack_public_path__ + "img/3_200.dc1b138a.png";